import React, { useRef, useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import download from "../../assets/downloadpdf.svg";
import whatsapp from "../../assets/icon-whatsapp2.svg";
import help from "../../assets/help.svg";
import { Document, Page, pdfjs } from "react-pdf";
import { useSelector } from "react-redux";
import { translations } from "../../translation/translate";
import ReportModal from "../../Components/ReportModa";
import useAddReport from "../../Hooks/addReport";

// FIX: Use version from the package, always works!
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function ReportPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pdfLink, setPdfLink] = useState("");
  const [saveResultErrorModal, setSaveResultErrorModal] = useState({
    open: false,
    message: "",
  });
  const [numPages, setNumPages] = useState(null);
  const [, setPageNumber] = useState(1);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const pdfContainerRef = useRef(null);
  const [pdfWidth, setPdfWidth] = useState(0);
  const pageRef = useRef(null);
  const [pageHeight, setPageHeight] = useState(0);
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const machineID = user.MachineID;
  const RefferedBy = localStorage.getItem("referedBy");
 
  // const referedBy = JSON.parse(localStorage.getItem("referedBy"))

  // Redux states
  const patientDetails = useSelector((state) => state.patientSlice.patientData);
  const langData = useSelector((state) => state.langSlice.langData);
  const updatedTestData = useSelector((state) => state.testSlice.testsData);

  const navigate = useNavigate();

  // PDF password: first 4 letters of name + last 4 digits of mobile number
  const pdfPassword = useMemo(() => {
    const namePart = String(patientDetails?.Name || "")
      .replace(/\s+/g, "")
      .slice(0, 4);
    const mobilePart = String(patientDetails?.contactNumber || "")
      .replace(/\D/g, "")
      .slice(-4);
    return namePart && mobilePart ? `${namePart}${mobilePart}` : "";
  }, [patientDetails?.Name, patientDetails?.contactNumber]);

  const UserData = JSON.parse(localStorage.getItem("userDetails") || "{}");
  const { addReport, response, error: addReportError } = useAddReport();
  const addReportCalledRef = useRef(false);

  // console.log(updatedTestData, "Updated Test Data");

  // console.log(updatedTestData.name, "Updated Test Data");

  const hasResultValue = (val) => {
    if (val === 0) return true;
    if (typeof val === "number") return !Number.isNaN(val);
    if (typeof val === "string") return val.trim() !== "";
    return val !== undefined && val !== null;
  };

  const getSubTests = (option = {}) => {
    if (Array.isArray(option.subTests)) return option.subTests;
    if (Array.isArray(option.subTest)) return option.subTest;
    return [];
  };

  const optionToReportEntries = (option = {}) => {
    const entries = [];
    const pushEntry = (id, value) => {
      if (id && hasResultValue(value)) {
        entries.push({ ParameterID: id, Result: value });
      }
    };

    if (option?.ParameterID) {
      pushEntry(option.ParameterID, option.result);
    }

    getSubTests(option).forEach((sub) => {
      const subId = sub?.ParameterID || sub?.id;
      const subResult = sub?.result ?? sub?.value;
      pushEntry(subId, subResult);
    });

    return entries;
  };

  const flattenFieldEntries = (field = {}) => {
    const entries = [];
    const pushEntry = (id, value) => {
      if (id && hasResultValue(value)) {
        entries.push({ ParameterID: id, Result: value });
      }
    };

    const fieldId =
      field?.ParameterID || field?.ParameterId || field?.fieldId || field?.id;
    const fieldValue = field?.result ?? field?.value;
    pushEntry(fieldId, fieldValue);

    const nestedSubs = Array.isArray(field?.subFields)
      ? field.subFields
      : Array.isArray(field?.subTests)
      ? field.subTests
      : Array.isArray(field?.subTest)
      ? field.subTest
      : [];

    nestedSubs.forEach((sub) => {
      const subId =
        sub?.ParameterID || sub?.ParameterId || sub?.fieldId || sub?.id;
      const subValue = sub?.result ?? sub?.value;
      pushEntry(subId, subValue);
    });

    return entries;
  };

  const buildBodyAnalysisEntries = (data = {}) => {
    const allSubs = Array.isArray(data?.fields)
      ? data.fields.flatMap((field) => field?.subFields || [])
      : [];

    return allSubs
      .map((subField) => ({
        ParameterID:
          subField?.ParameterId ||
          subField?.ParameterID ||
          subField?.fieldId ||
          subField?.id,
        Result: subField?.value ?? subField?.result,
      }))
      .filter((entry) => entry.ParameterID && hasResultValue(entry.Result));
  };

  const reportList = useMemo(() => {
    if (!updatedTestData) return [];

    const isBodyAnalysisObject =
      !Array.isArray(updatedTestData) &&
      updatedTestData?.name === "Body Analysis";

    if (isBodyAnalysisObject) {
      return buildBodyAnalysisEntries(updatedTestData);
    }

    const testsArray = Array.isArray(updatedTestData) ? updatedTestData : [];

    return testsArray.flatMap((item) => {
      if (Array.isArray(item?.options) && item.options.length > 0) {
        return item.options.flatMap(optionToReportEntries);
      }
      if (Array.isArray(item?.fields) && item.fields.length > 0) {
        return item.fields.flatMap(flattenFieldEntries);
      }
      return [];
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedTestData]);

  const downloadLinks = useMemo(() => {
    const links = [];

    if (pdfLink) {
      links.push({
        label: "Combined Report",
        url: pdfLink,
        fileName: `${patientDetails.Name || "Report"}_${
          patientDetails.PatientID || ""
        }.pdf`,
      });
    }

    if (Array.isArray(response?.data)) {
      response.data.forEach((item, idx) => {
        const [labelKey] = Object.keys(item || {});
        const linkUrl = labelKey ? item[labelKey] : null;

        if (linkUrl) {
          links.push({
            label: labelKey || `Report ${idx + 1}`,
            url: linkUrl,
            fileName: `${patientDetails.Name || "Report"}_${
              labelKey || idx + 1
            }.pdf`,
          });
        }
      });
    }

    return links;
  }, [pdfLink, response?.data, patientDetails.Name, patientDetails.PatientID]);

  useEffect(() => {
    if (
      addReportCalledRef.current ||
      pdfLink ||
      !patientDetails?.PatientID ||
      reportList.length === 0 ||
      !UserData?.token
    ) {
      return;
    }

    addReportCalledRef.current = true;
    let isSubscribed = true;

    const submitReport = async () => {
      setLoading(true);
      try {
        // 🔹 addReport returns backend JSON directly (not { data: ... })
        // console.log("----start---")
        const data = await addReport({
          PatientID: patientDetails.PatientID,
          ReferredBy: (RefferedBy || "").toUpperCase(),
          MachineID: machineID,
          Report: reportList,
          token: UserData.token,
        });

        // if (!isSubscribed) return;

        // console.log("addReport data:", data);

        if (!data) {
          console.warn("addReport returned null (probably error in hook)");
          return;
        }

        if (data?.error === true) {
          const message =
            data?.message ||
            data?.data?.message ||
            "Unable to save report result.";
          setSaveResultErrorModal({ open: true, message });
          return;
        }

        // ✅ Use the correct key from backend, e.g. combinedPdf
        if (data.combinedPdf) {
          setPdfLink(data.combinedPdf);
          // console.log(data.combinedPdf, "----pdf---combined");
          localStorage.setItem("reportLink", data.combinedPdf);
        } else {
          console.warn("No combinedPdf in response:", data);
        }
      } catch (err) {
        if (isSubscribed) {
          console.error("Failed to save report:", err);
        }
      } finally {
        setLoading(false);
      }
    };

    submitReport();

    return () => {
      isSubscribed = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pdfLink,
    patientDetails?.PatientID,
    reportList,
    UserData?.token,
    addReport,
  ]);

  // Clear any stale report link from a previous patient on mount
  useEffect(() => {
    localStorage.removeItem("reportLink");
  }, []);

  useEffect(() => {
    if (!addReportError) return;
    setSaveResultErrorModal({
      open: true,
      message: addReportError,
    });
  }, [addReportError]);

  // Fill only the space below the navbar so the window itself never scrolls
  useEffect(() => {
    const updateHeight = () => {
      const el = pageRef.current;
      if (!el) return;
      setPageHeight(window.innerHeight - el.getBoundingClientRect().top);
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("resize", updateHeight);
      document.body.style.overflow = prevOverflow;
    };
  }, []);

  // Keep rendered PDF pages sized to the viewer container
  useEffect(() => {
    const el = pdfContainerRef.current;
    if (!el) return;
    const observer = new ResizeObserver(([entry]) => {
      setPdfWidth(Math.floor(entry.contentRect.width));
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [pdfLink]);

  // For PDF load success
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  const handleDirectDownload = async (url, fileName) => {
    try {
      setLoading(true);

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName || "Report.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download report. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Auto-fill computed password; fall back to manual entry if it's missing or wrong
  const handlePdfPassword = (callback, reason) => {
    if (reason === pdfjs.PasswordResponses.NEED_PASSWORD && pdfPassword) {
      callback(pdfPassword);
    } else {
      const entered = window.prompt("Enter PDF password");
      if (entered === null) {
        callback(new Error("Password entry cancelled"));
      } else {
        callback(entered);
      }
    }
  };

  // Reports are password-protected, so the browser's PDF viewer can't print them
  // silently. Decrypt with pdf.js, render pages to images and print those instead.
  const handleInstantPrint = async (url) => {
    let pdfDoc;
    try {
      setLoading(true);

      const res = await fetch(url);
      if (!res.ok) throw new Error("Failed to fetch report");
      const data = await res.arrayBuffer();

      const loadingTask = pdfjs.getDocument({ data });
      loadingTask.onPassword = handlePdfPassword;
      pdfDoc = await loadingTask.promise;

      const pageImages = [];
      for (let i = 1; i <= pdfDoc.numPages; i++) {
        const page = await pdfDoc.getPage(i);
        const viewport = page.getViewport({ scale: 2 });
        const canvas = document.createElement("canvas");
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({ canvasContext: canvas.getContext("2d"), viewport })
          .promise;
        pageImages.push(canvas.toDataURL("image/png"));
      }

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      document.body.appendChild(iframe);

      const printDoc = iframe.contentDocument;
      printDoc.open();
      printDoc.write(`<!doctype html><html><head><style>
        @page { margin: 0; }
        html, body { margin: 0; padding: 0; }
        img { display: block; width: 100%; page-break-after: always; break-after: page; }
        img:last-child { page-break-after: auto; break-after: auto; }
      </style></head><body>${pageImages
        .map((src) => `<img src="${src}" />`)
        .join("")}</body></html>`);
      printDoc.close();

      await Promise.all(
        Array.from(printDoc.images).map((img) =>
          img.complete
            ? Promise.resolve()
            : new Promise((resolve) => {
                img.onload = resolve;
                img.onerror = resolve;
              })
        )
      );

      const win = iframe.contentWindow;
      win.onafterprint = () => iframe.remove();
      setLoading(false);
      win.focus();
      win.print();
    } catch (err) {
      console.error("Print error", err);
      if (err?.message !== "Password entry cancelled") {
        alert("Failed to print report. Please try again.");
      }
    } finally {
      pdfDoc?.destroy();
      setLoading(false);
    }
  };

  const handleSaveResultErrorOk = () => {
    setSaveResultErrorModal({ open: false, message: "" });
    navigate("/search-patient", { replace: true });
  };

  return (
    <>
      <div
        ref={pageRef}
        style={{ height: pageHeight || undefined }}
        className="bg-[#C7CEE5] flex justify-center overflow-hidden px-6 py-4 z-10 relative"
      >
        <div className="bg-[#C7CEE5] flex flex-col items-center justify-center h-full w-full z-10 relative">
          {/* PDF Display Section */}

          {pdfLink ? (
            <div className="w-full max-w-5xl h-full flex flex-col overflow-hidden rounded-2xl bg-white shadow-xl ring-1 ring-black/5">
              {/* Viewer header */}
              <div className="flex items-center justify-between gap-4 border-b border-gray-200 bg-white px-5 py-3">
                <div className="flex min-w-0 items-center gap-3">
                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#845BB3]/10 text-xs font-bold text-[#845BB3]">
                    PDF
                  </div>
                  <div className="min-w-0">
                    <p className="truncate text-sm font-semibold text-gray-900">
                      {patientDetails?.Name || "Patient"} — Test Report
                    </p>
                    {patientDetails?.PatientID && (
                      <p className="truncate text-xs text-gray-500">
                        Patient ID: {patientDetails.PatientID}
                      </p>
                    )}
                  </div>
                </div>
                {numPages > 0 && (
                  <span className="shrink-0 rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-600">
                    {numPages} {numPages === 1 ? "page" : "pages"}
                  </span>
                )}
              </div>

              {/* Pages */}
              <div
                ref={pdfContainerRef}
                className="flex-1 overflow-y-auto bg-[#EEF0F6] p-4 sm:p-6"
              >
                <Document
                  file={pdfLink}
                  onPassword={handlePdfPassword}
                  onLoadSuccess={onDocumentLoadSuccess}
                  className="flex flex-col items-center gap-6"
                  loading={
                    <div className="flex flex-col items-center gap-3 py-32 text-gray-500">
                      <div className="h-8 w-8 animate-spin rounded-full border-4 border-[#845BB3]/20 border-t-[#845BB3]" />
                      <span className="text-sm">Loading report...</span>
                    </div>
                  }
                  error={
                    <div className="py-32 text-center text-sm text-red-500">
                      Failed to load the report. Please try again.
                    </div>
                  }
                >
                  {Array.from({ length: numPages || 0 }, (_, i) => (
                    <div
                      key={i}
                      className="overflow-hidden rounded-md bg-white shadow-md"
                    >
                      <Page
                        pageNumber={i + 1}
                        width={pdfWidth ? Math.min(pdfWidth, 900) : undefined}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                      />
                    </div>
                  ))}
                </Document>
              </div>
            </div>
          ) : (
            <div className="text-lg text-gray-500 py-32 px-10">
              Loading PDF...
            </div>
          )}
        </div>

        {/* Go Back Button */}
        <div
          onClick={() => navigate("/tests", { replace: true })}
          className="fixed left-11 top-[15%] text-[#845BB3] bg-white my-2 px-4 py-2 text-md font-bold font-sans rounded cursor-pointer shadow-sm z-10"
        >
          {translations[langData].GoBack}
        </div>

        {/* Floating Action Buttons */}
        <div className="fixed bottom-8 right-8 lg:right-20 z-10">
          <div className="relative group mb-4">
            <button
              type="button"
              onClick={() => setIsDownloadModalOpen(true)}
              className="focus:outline-none"
            >
              <img
                src={download}
                alt="Download PDF"
                className="w-10 lg:w-12 cursor-pointer hover:scale-110 transition-transform"
              />
            </button>
            <span className="absolute right-14 top-1/2 -translate-y-1/2 bg-[#845BB3] text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity">
              Download
            </span>
          </div>
          <div className="relative group mb-4">
            <img
              src={whatsapp}
              alt="Upload PDF"
              className="w-10 lg:w-12 cursor-pointer hover:scale-110 transition-transform"
              onClick={() => setIsModalOpen(true)}
            />
            <span className="absolute right-14 top-1/2 -translate-y-1/2 bg-[#845BB3] text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity">
              WhatsApp
            </span>
          </div>
          <div className="relative group">
            <a href="../faq">
              <img
                src={help}
                alt="Help icon"
                className="w-10 lg:w-12 hover:scale-110 transition-transform"
              />
            </a>
            <span className="absolute right-14 top-1/2 -translate-y-1/2 bg-[#845BB3] text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity">
              FAQs
            </span>
          </div>
        </div>

        {isDownloadModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
            <div className="w-full max-w-3xl overflow-hidden rounded-2xl border border-purple-100 bg-white shadow-2xl">
              <div className="flex items-start justify-between bg-gradient-to-r from-purple-600 to-indigo-500 px-6 py-4 text-white">
                <div>
                  <p className="text-lg font-semibold">Download Reports</p>
                  <p className="text-sm opacity-80">
                    Choose any link below to open, download, or print.
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => setIsDownloadModalOpen(false)}
                  className="rounded-full bg-white/15 p-2 text-white transition hover:bg-white/25 focus:outline-none"
                  aria-label="Close download modal"
                >
                  ✕
                </button>
              </div>

              <div className="bg-gradient-to-br from-purple-50 via-white to-blue-50 p-6">
                {downloadLinks.length > 0 ? (
                  <div className="space-y-3">
                    {downloadLinks.map((item, idx) => (
                      <div
                        key={`${item.url}-${idx}`}
                        className="flex flex-col gap-3 rounded-xl border border-purple-100 bg-white/90 p-4 shadow-sm backdrop-blur-sm sm:flex-row sm:items-center sm:justify-between"
                      >
                        <div className="min-w-0">
                          <p className="text-sm font-semibold text-purple-900">
                            {item.label}
                          </p>
                          {/* <p className="break-all text-xs text-gray-600">
                            {item.url}
                          </p> */}
                        </div>
                        <div className="flex flex-wrap items-center gap-2">
                          <a
                            href={item.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="rounded-lg border border-purple-200 bg-white px-4 py-2 text-sm font-semibold text-purple-700 shadow-sm transition hover:bg-purple-50 focus:outline-none"
                          >
                            Open
                          </a>
                          <button
                            type="button"
                            onClick={() =>
                              handleDirectDownload(item.url, item.fileName)
                            }
                            className="inline-flex items-center justify-center rounded-lg border border-purple-200 bg-purple-50 px-4 py-2 text-sm font-semibold text-purple-700 shadow-sm transition hover:bg-purple-100 focus:outline-none"
                          >
                            Download
                          </button>
                          <button
  type="button"
  onClick={() => handleInstantPrint(item.url)}
  className="inline-flex items-center justify-center rounded-lg border border-purple-200 bg-purple-50 px-4 py-2 text-sm font-semibold text-purple-700 shadow-sm transition hover:bg-purple-100 focus:outline-none"
>
  Print
</button>

                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="rounded-xl border-2 border-dashed border-purple-200 bg-white/70 p-6 text-center text-gray-600">
                    No report links available yet. Please wait for the report to
                    finish generating.
                  </div>
                )}

                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    onClick={() => setIsDownloadModalOpen(false)}
                    className="rounded-lg px-4 py-2 text-sm font-semibold text-purple-700 transition hover:bg-purple-100 focus:outline-none"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}


        {/* Loader */}
        {loading && (
          <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-800 bg-opacity-50 z-50">
            <div className="w-10 h-10 border-4 border-t-red-500 border-gray-300 rounded-full animate-spin"></div>
            <div className="mt-4 text-white text-lg font-semibold">
              It May Take Upto 2 Minutes
            </div>
          </div>
        )}
        <ReportModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          reportLink={response?.data}
          loading={loading}
          setLoading={setLoading}
        />

        {saveResultErrorModal.open && (
          <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 px-4">
            <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-2xl">
              <h3 className="text-lg font-semibold text-red-600">Error</h3>
              <p className="mt-3 text-sm text-gray-700">
                {saveResultErrorModal.message}
              </p>
              <div className="mt-6 flex justify-end">
                <button
                  type="button"
                  onClick={handleSaveResultErrorOk}
                className="px-4 py-2 rounded-lg text-sm font-medium text-black border border-gray-300 hover:bg-[#c8cee5]"



                >
                  OK
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
